/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductExpressUpdateElement } from './ProductExpressUpdateElement';
import {
    ProductExpressUpdateElementFromJSON,
    ProductExpressUpdateElementFromJSONTyped,
    ProductExpressUpdateElementToJSON,
} from './ProductExpressUpdateElement';

/**
 * Representation of a Product Express Update Element List
 * @export
 * @interface ProductExpressUpdateElementList
 */
export interface ProductExpressUpdateElementList {
    /**
     * List of product express update element
     * @type {Array<ProductExpressUpdateElement>}
     * @memberof ProductExpressUpdateElementList
     */
    productExpressUpdateElements?: Array<ProductExpressUpdateElement>;
}

/**
 * Check if a given object implements the ProductExpressUpdateElementList interface.
 */
export function instanceOfProductExpressUpdateElementList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductExpressUpdateElementListFromJSON(json: any): ProductExpressUpdateElementList {
    return ProductExpressUpdateElementListFromJSONTyped(json, false);
}

export function ProductExpressUpdateElementListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductExpressUpdateElementList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productExpressUpdateElements': !exists(json, 'productExpressUpdateElements') ? undefined : ((json['productExpressUpdateElements'] as Array<any>).map(ProductExpressUpdateElementFromJSON)),
    };
}

export function ProductExpressUpdateElementListToJSON(value?: ProductExpressUpdateElementList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'productExpressUpdateElements': value.productExpressUpdateElements === undefined ? undefined : ((value.productExpressUpdateElements as Array<any>).map(ProductExpressUpdateElementToJSON)),
    };
}

